
import React from 'react';
import { VSLeadsTimerOverlay } from '@/components/vsleads/VSLeadsTimerOverlay';
import { FormCaptureFields } from '@/components/vsleads/types';

interface FormOverlayProps {
  formConfig?: FormCaptureFields;
  showForm: boolean;
  handleFormSubmit: () => void;
}

export const FormOverlay: React.FC<FormOverlayProps> = ({ 
  formConfig, 
  showForm, 
  handleFormSubmit 
}) => {
  if (!formConfig || !formConfig.timerEnabled || !showForm) {
    return null;
  }

  return (
    <VSLeadsTimerOverlay
      config={formConfig}
      onSubmit={handleFormSubmit}
      isVisible={showForm}
    />
  );
};
